import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import ProductsHero from "./components/ProductsHero";
import ProductSections from "./components/ProductSections";
import ProductComparisonTable from "./components/ProductComparisonTable";
import BespokeServicesCTA from "./components/BespokeServicesCTA";
import ProductAdvisorCTA from "./components/ProductAdvisorCTA";
import ProductsFinalCTA from "./components/ProductsFinalCTA";
import { usePageMeta } from "../../hooks/usePageMeta";

export default function ProductsPage() {
  usePageMeta(
    "Products | StackMap Systems - 11 BOS Modules, OMS, Get Fit & Custom Solutions",
    "Explore StackMap's ecosystem: 11 connected BOS modules, OMS standalone order management platform, Get Fit vertical SaaS for gyms, and bespoke software development. Built for connected operations."
  );

  return (
    <div className="min-h-screen bg-graphite-900">
      <Navbar />
      <main>
        <ProductsHero />
        <ProductSections />
        <ProductComparisonTable />
        <BespokeServicesCTA />
        <ProductAdvisorCTA />
        <ProductsFinalCTA />
      </main>
      <Footer />
    </div>
  );
}